import { FC } from "react";
import { BubbleWithText } from "../BubbleWithText";

import './BubbleSequence.scss';

interface BubbleSequenceProps {
    amount: number | string;
    /** Inclusive first number shown; default 1 (e.g. 0 for score 0..N-1 with amount N) */
    startAt?: number;
}

export const BubbleSequence: FC<BubbleSequenceProps> = ({ amount, startAt = 1 }) => (
    <div className="bubble-sequence">
        {(new Array(Number(amount))).fill(null).map((_, index) => (
            <div key={`bubble-sequence-index-${index}`} className="bubble-sequence__item">
                <BubbleWithText content={index + startAt} />
            </div>
        ))}
    </div>
);
